import React, { useContext } from 'react';
import { Auth0Context } from 'status/context';

const useAuth0 = () => useContext(Auth0Context);

export default useAuth0;
